// extracted by mini-css-extract-plugin
module.exports = {"root":"_2-SU7","message":"_1ibOp","input":"_3tLVz","error":"_1bPjw","footer":"_32Rro","submit":"_1lFJN","preloader":"_1J4FM","disabled":"_1g5mC","pending":"pPdw0"};